console.log('%cmedia-gallery.js LOADED', 'color:#0b5;font-weight:bold');

if (!customElements.get('media-gallery')) {
  console.log('%cDefining <media-gallery>', 'color:#0b5;font-weight:bold');

  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      console.log('<media-gallery> constructor', this);

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) {
        console.warn('No thumbnails – continuing without');
        return;
      }

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 300));

      const thumbButtons = this.elements.thumbnails.querySelectorAll('[data-target]');
      console.log(`Found ${thumbButtons.length} thumbnails`);

      thumbButtons.forEach((thumb, idx) => {
        const btn = thumb.querySelector('button');
        if (!btn) return;
        btn.addEventListener('click', e => {
          e.preventDefault();
          console.log(`Thumbnail #${idx + 1} CLICKED → ${thumb.dataset.target}`);
          this.setActiveMedia(thumb.dataset.target, false);
        });
      });

      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    // onSlideChanged(event) {
    //   const mediaId = event.detail.currentElement.dataset.mediaId;
    //   const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
    //   if (thumb) this.setActiveThumbnail(thumb);
    // }
    onSlideChanged(event) {
      // Safety check: Prevent fatal crashes if an app sends a malformed event
      if (!event.detail || !event.detail.currentElement) {
        console.warn('slideChanged event fired without currentElement details', event);
        return; 
      }
      
      const mediaId = event.detail.currentElement.dataset.mediaId;
      const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (thumb) this.setActiveThumbnail(thumb);
    }

    setActiveMedia(mediaId, prepend = false) {
  console.log('%csetActiveMedia → ' + mediaId, 'color:#06d');
  const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
  if (!activeMedia) return console.error('Media not found:', mediaId);

  // Update .is-active
  this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
  activeMedia.classList.add('is-active');

  // Get index
  const slides = this.elements.viewer.querySelectorAll('.slider__slide');
  const idx = Array.from(slides).indexOf(activeMedia);

  // 1. Dispatch slideTo (Dawn native)
  const sliderComp = this.elements.viewer.closest('slider-component');
  if (sliderComp) {
    sliderComp.dispatchEvent(new CustomEvent('slideTo', { detail: { index: idx } }));
    console.log('%c→ slideTo dispatched', 'color:#0b5');
  }

  // 2. Fallback: force Slick if jQuery is available
  setTimeout(() => {
    const slickEl = this.elements.viewer.querySelector('.slider');
    if (slickEl && window.jQuery && $.fn.slick) {
      $(slickEl).slick('slickGoTo', idx);
      console.log('%cFALLBACK: Slick forced to ' + idx, 'color:#f90');
    }
  }, 50);

  // 3. Sync thumbnail via slideChanged
  this.elements.viewer.dispatchEvent(new CustomEvent('slideChanged', {
    detail: { currentElement: activeMedia }
  }));

  // Load media
  this.playActiveMedia(activeMedia);

  // Update thumbnail
  const thumb = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
  if (thumb) this.setActiveThumbnail(thumb);

  // Scroll fallback
  setTimeout(() => activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 100);
}

    setActiveThumbnail(thumbnail) {
      if (!thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach(b => b.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', 'true');
    }

    playActiveMedia(item) {
      window.pauseAllMedia?.();
      const dm = item.querySelector('deferred-media');
      if (dm) dm.loadContent(false);
    }

    announceLiveRegion(item, pos) {
      if (!this.elements.liveRegion) return;
      const img = item.querySelector('img');
      if (!img) return;
      const announce = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.textContent = `Image ${pos} loaded`;
        setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
      };
      img.complete ? announce() : (img.onload = announce);
    }

    removeListSemantic() {
      const s = this.elements.viewer.querySelector('.slider');
      if (s) {
        s.setAttribute('role', 'presentation');
        s.querySelectorAll('.slider__slide').forEach(el => el.setAttribute('role', 'presentation'));
      }
    }
  });

  console.log('%c<media-gallery> DEFINED', 'color:#0b5;font-weight:bold');
  console.log('jQuery?', !!window.jQuery);
console.log('Slick?', !!(window.jQuery && $.fn.slick));
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}